import { z } from 'zod'

import baseSchemaFields from './base-schema'
import { makeTypeLiteral } from './helpers'

export default z.object({
  ...baseSchemaFields,
  type: makeTypeLiteral('boolean'),
  defaultValue: z.boolean().nullable(),
})
